<template>
  <div class="machine-alerts" :style="{ fontSize: fontSize }">

    <loading v-if="warningMachines === null" />

    <table v-if="warningMachines" class="table is-hoverable is-bordered alerts">
      <thead>
        <tr>
          <th>Name</th>
          <th>SMU</th>
          <th>Next Service</th>
          <th>Alert(s)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m of warningMachines" :key="m._id"
          :class="{warning: m.service === 'due' || m.repairs, danger: m.service === 'overdue' || m.repairsUrgent}"
        >
          <td>{{ m.name }}</td>
          <td>{{ m.smu | prettyNumber }} {{ m.units }}</td>
          <td>{{ m.nextService | prettyNumber }}</td>
          <td>
            <div class="tags">
              <span v-if="m.service === 'due'" class="tag is-warning">service due</span>
              <span v-else-if="m.service === 'overdue'" class="tag is-danger">SERVICE OVERDUE</span>

              <span v-if="m.repairsUrgent" class="tag is-danger">URGENT REPAIRS</span>
              <span v-else-if="m.repairs" class="tag is-warning">repairs needed</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  data () {
    return {
      machines: null,
      warningMachines: null,
      fontSize: '1em'
    }
  },
  created () {
    this.subs.system = this.$firestore.doc('/settings/system')
      .onSnapshot(ss => {
        let obj = this.$utils.snapshotToObj(ss)
        if (obj && obj.displayFontSize) {
          this.fontSize = obj.displayFontSize
        }
      })

    this.subs.machines = this.$firestore.collection('machines')
      .orderBy('name')
      .onSnapshot(snapshot => {
        this.machines = this.$utils.snapshotToArr(snapshot)
        this.updateWarningMachines()
      })

    this.subs.machineRepairs = this.$firestore.collection('machineRepairs')
      .where('timestampFixed', '==', 0)
      .onSnapshot(snapshot => {
        this.repairs = this.$utils.snapshotToArr(snapshot)
        this.updateWarningMachines()
      })
  },
  methods: {
    updateWarningMachines () {
      if (!this.machines) {
        return
      }

      let obj = {}

      for (let machine of this.machines) {
        if (machine.nextService === 0) continue

        if (machine.smu > machine.nextService) {
          machine.service = 'overdue'
          console.log('overdue', machine.name)
        } else if (machine.smu >= machine.nextService - machine.serviceWarning) {
          machine.service = 'due'
        } else {
          delete machine.service
        }
        if (machine.service) {
          obj[machine._id] = machine
        }
      }

      if (this.repairs) {
        for (let r of this.repairs) {
          let machine = obj[r.machineId]
          if (!machine) {
            machine = this.machines.find(m => m._id === r.machineId)
            if (!machine) {
              continue
            }
            obj[r.machineId] = machine
          }
          machine.repairs = true
          if (r.urgent) {
            machine.repairsUrgent = true
          }
        }
      }

      const arr = []
      for (const key in obj) {
        arr.push(obj[key])
      }
      const score = (m) => {
        let score = 0
        if (m.repairsUrgent) score += 100
        if (m.service === 'overdue') score += 50
        if (m.repairs) score += 2
        if (m.service === 'due') score += 1
        return score
      }
      arr.sort((a, b) => {
        const aScore = score(a)
        const bScore = score(b)
        if (aScore !== bScore) return bScore - aScore
        return a.name.trim().toLocaleLowerCase().localeCompare(b.name.trim().toLocaleLowerCase())
      })
      this.warningMachines = arr
    }
  }
}
</script>
